import { createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import * as generateAgreementFormTypes from './generateAgreementFormTypes';

export const onSaveButtonClick = createAction(generateAgreementFormTypes.SAVE_BUTTON_CLIKED);
export const submitAgreementForm = createFormAction(generateAgreementFormTypes.SUBMIT_AGREEMENT_FORM);
